import { Optional } from 'utility-types';
import { Tooltip, TooltipProps } from './Tooltip';

type OptionalTooltipProps = Optional<TooltipProps> & { hide: boolean };

export const OptionalTooltip = ({ hide, ...props }: OptionalTooltipProps) => {
  return hide ? props.children! : <Tooltip {...(props as TooltipProps)} />;
};
